<div>
  <h4 class="m-t-0" mat-dialog-title>{{'commentTo' | translate}} "{{name}}"</h4>
  <p>{{comment}}.</p>
  <!-- </div>
  <div mat-dialog-actions > -->
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="basic" (click)="closeDialog()">{{'hide' | translate}}</button>
  </div>  

</div>